import { CustomIconProps } from './index';

export const BreakIcon = ({ color }: CustomIconProps) => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M10 10l4-2v6l-4 3v-7z" fill="#fff" />
            <rect
                x={5.438}
                y={11.634}
                width={14}
                height={2}
                rx={1}
                transform="rotate(-30 5.438 11.634)"
                fill="#C3CDD5"
            />
            <rect
                x={5.438}
                y={17.634}
                width={14}
                height={2}
                rx={1}
                transform="rotate(-30 5.438 17.634)"
                fill="#C3CDD5"
            />
            <path fill="#C3CDD5" d="M11 15h2v9h-2zM11 0h2v9h-2z" />
        </svg>
    );
};
